const patterns = [
  "Sliding Window",
  "Two Pointers",
  "Fast & Slow Pointers",
  "Merge Intervals",
  "Cyclic Sort",
  "In-place Reversal of a Linked List",
  "Breadth-First Search (BFS)",
  "Inorder Traversal (DFS)",
  "Preorder Traversal (DFS)",
  "Postorder Traversal (DFS)",
  "Top K Elements (Heap)",
  "K-way Merge",
  "Subsets (Backtracking)",
  "Bit Manipulation",
  "1-Dimension DP",
  "2-Dimension DP",
  "Greedy Algorithms",
  "Binary Search"
];

export default patterns;
